export default __webpack_public_path__ + "static/team-member_t-757bc952ccb2832e8840198291bf76ab.jpg";